<template>
    <div class="assignment-report">
        <div class="header-title">
            <h3>{{$t('homeworkReport')}}</h3>
        </div>
        <v-form class="select-form select-clear-block" ref="form" style="align-items: flex-start; gap: 8px">
            <v-select outlined dense :no-data-text="$t('no_data')" :items="schoolQuarters"
                item-text="semester" item-value="id" :label="$t('quarter')" class="v-select-item"
                @change="onSelectQuarter"/>
            <v-btn color="primary" style="height: 40px" @click="submitGenerate" v-text="$t('generate')"/>
        </v-form>

        <div class="report-content" v-if="reportAssignData.length">
            <v-simple-table class="tab-st">
                <template v-slot:default>
            <thead>
            <tr>
                <th>{{ $t('class') }}</th>
                <th>{{ $t('teacher') }}</th>
                <th>Кол-во ДЗ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in reportAssignData" :key="i">
                <td>{{item.classTitle}}</td>
                <td>{{item.instructorTitle}}</td>
                <td>{{item.assignmentCount}}</td>
            </tr>
            </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
import AnalyticsService from '@/_services/analytics.service'
export default {
  props: {
    schoolQuarters: Array
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  data () {
    return {
      reportAssignData: [],
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    onSelectQuarter (id) {
      const selectedQuarter = this.schoolQuarters.find((quarter) => quarter.id === id)
      this.startDate = new Date(selectedQuarter.startDate).toLocaleDateString('ru')
      this.endDate = new Date(selectedQuarter.endDate).toLocaleDateString('ru')
    },

    submitGenerate () {
      AnalyticsService.fetchAssignmentReport(this.school.id, this.startDate, this.endDate).then((res) => {
        this.reportAssignData = res
      }).catch(err => {
        this.$toast.error(err)
      })
    }
  }
}
</script>
